<template>
    <vx-expandable-card data-test="teams-card">
        <template v-slot:content>
            <div class="text-xl font-extrabold mb-4">Voxie teams</div>
            <vx-alert v-if="!props.teams.length" color="slate" :closeable="false" data-test="teams-empty">
                {{ props.emptyText }}
            </vx-alert>
            <vx-table v-else class="xl:grid-cols-5" rowBreakpoint="xl">
                <vx-table-row isHeader>
                    <div>Team</div>
                    <div>Name</div>
                    <div>Status</div>
                    <div>Numbers</div>
                    <div></div>
                </vx-table-row>
                <vx-table-row v-for="team in props.teams" :key="team.team_id" :data-test="`team-${team.team_id}`">
                    <vx-table-row-title>
                        <vx-badge color="slate" size="xs">{{ team.team_id }}</vx-badge>
                    </vx-table-row-title>
                    <vx-table-row-item>
                        <template v-slot:label> Name: </template>
                        <span class="text-sm font-bold">{{ team.name }}</span>
                    </vx-table-row-item>
                    <vx-table-row-item>
                        <template v-slot:label> Status: </template>
                        {{ formatTeamStatus(team.status) }}
                    </vx-table-row-item>
                    <vx-table-row-item>
                        <template v-slot:label> Numbers: </template>
                        {{ team.phone_numbers_count }}
                    </vx-table-row-item>
                    <vx-table-row-buttons>
                        <vx-button
                            :href="`/kiosk/teams/${team.team_id}`"
                            size="sm"
                            data-test="view-team"
                            outline
                            color="muted"
                        >
                            View <font-awesome-icon widthAuto :icon="faEye" />
                        </vx-button>
                    </vx-table-row-buttons>
                </vx-table-row>
            </vx-table>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { faEye } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxAlert,
    VxBadge,
    VxButton,
    VxExpandableCard,
    VxTable,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
} from '@voxie/frontend-components';
import type { TcrTeamHolding } from '~/services/adminTenDlcRegistrationClient.types';
import { formatTeamStatus } from '~/utils/team';

const props = withDefaults(defineProps<{ teams: TcrTeamHolding[]; emptyText?: string }>(), {
    emptyText: "No Voxie numbers are attached to this brand's campaigns yet",
});
</script>
